import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import middlewares from './middlewares';
import reducers from './reducers';

const { REACT_APP_REDUX_LOGGER, NODE_ENV } = process.env;

const setupStore = initialState => {
  if (REACT_APP_REDUX_LOGGER !== 'false' && NODE_ENV !== 'production') {
    const reduxLogger = createLogger({
      collapsed: true,
    });
    middlewares.push(reduxLogger);
  }
  return createStore(
    reducers,
    initialState,
    composeWithDevTools(applyMiddleware(thunk, ...middlewares))
  );
};

/* eslint-enable */
export default setupStore;
